import { memo } from 'react';
import { cn, Price } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import styles from './ToAddress.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ToAddressProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  hasProductsInCart?: boolean;
}

const ToAddress: FC<ToAddressProps> = (props) => {
  const { className, hasProductsInCart, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <div {...restProps} className={cn(styles.container, className)}>
      {!hasProductsInCart && (
        <div className={styles.title}>
          {t('to-adress.title')}
          <Price className={styles.price} price={1689} />
        </div>
      )}

      <div className={styles.text}>{t('to-adress.description')}</div>
    </div>
  );
};

export default memo(ToAddress);
